module.exports = __webpack_public_path__ + "img/darkmode-video-preview-step1.e00a508b.svg";